import NotificationToast from '_base/Notification'

function connectionOnline() {
  NotificationToast('info', 'Online', 'You are back online. Refresh page to get establish connection.')
}

function connectionOffline() {
  NotificationToast('warning', 'Offline', 'Check your internet connection and try again later.')
}

function connectionStatus() {
  window.addEventListener('offline', connectionOffline)
  window.addEventListener('online', connectionOnline)
}
export default connectionStatus
